import React from 'react';
import { useParams, useLocation } from 'react-router-dom';

export const TankEditExternalPage = () => {
    const { id } = useParams<{ id: number }>();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl') || '';
    const hash = location.hash || '';

    return (
        <iframe
            style={{ width: '100%', height: '100%' }}
            src={`/embed/tanks/${id}/edit?returnUrl=${encodeURIComponent(
                returnUrl
            )}${hash}`}
        />
    );
};
